const isLocalFrontend =
  typeof window !== "undefined" &&
  (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  );

export const API_URL =
  process.env.REACT_APP_API_URL ||
  "https://chatrasangbad.onrender.com";


export const getMediaUrl = (
  value
) => {

  if (!value) {
    return "";
  }

  if (
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (value.startsWith("/uploads/")) {
    return `${API_URL}${value}`;
  }

  return value;

};